import { computed, toRef } from "vue";
import { useMyField } from "~/lib/myVeeValidate";
import addVModelWatchers from "~/composables/add-v-model-watchers";

export const fieldProps = {
  modelValue: null,
  schemaField: null,
  disabled: {
    type: Boolean,
    default: false,
  },
};

export const fieldEmits = {
  "update:modelValue": null,
};

export default function initValidationField({ props, emit, fieldRef }) {
  const { value, meta, errorMessage, handleBlur, validate } = useMyField(
    toRef(props, "schemaField"),
    null,
    {
      initialValue: props.modelValue,
      validateOnValueUpdate: false,
    },
    fieldRef
  );

  addVModelWatchers({ props, emit, dataRef: value });

  const isFieldInvalid = computed(() => !meta.valid && errorMessage.value);

  function onBlur(e) {
    handleBlur(e);
    validate();
  }

  return { value, isFieldInvalid, errorMessage, onBlur, validate };
}
